import React from 'react';
import {Col, Row} from "antd";
import {
    FaFacebookF,
    FaTelegram,
    FaYoutube,
    FaInstagram,
    FaDiscord, FaXTwitter,
    FaTiktok
} from 'react-icons/fa6';
import {useModel} from "@@/exports";
import zhCN from "@/locales/zh-CN";
import useTrans from "@/hooks/useTranslateGoogleHook";
import PolicyModal from '@/components/PrivacyPolicy'
import useFormattedMessage from "@/hooks/useFormattedMessage";

const Footer: React.FC = () => {
    // const keys = Object.keys(zhCN)?.filter(key => key.startsWith('pages.footer')).map(key => zhCN[key]); // 提取值首页需要翻译的值
    // const {langs} = useTrans({keys})
    const {formatterMessage} = useFormattedMessage()
    const { data } = useModel('globalData')
    const media= data?.media;

  return (
      <div className="footer-main">
          <div className="page-content">
              <Row>
                  <Col md={10} className="join-us">
                      <p>{formatterMessage('pages.footer.text1')}</p>
                      <span>{formatterMessage('pages.footer.text2')}</span>
                      <div className="join-us-icon">
                          <a href={media?.tiktok} target="_blank"><FaTiktok/></a>
                          <a href={media?.telegram} target="_blank"><FaTelegram/></a>
                          <a href={media?.twitter} target="_blank"><FaXTwitter/></a>
                          <a href={media?.youtube} target="_blank"><FaYoutube/></a>
                          <a href={media?.instagram} target="_blank"><FaInstagram/></a>
                          <a href={media?.discord} target="_blank"><FaDiscord/></a>
                      </div>
                  </Col>
                  <Col md={14} className="footer-lists_outer">
                      <div>
                          <p>{formatterMessage('pages.footer.text3')}</p>
                          <a href="#">{formatterMessage('pages.footer.text4')}</a>
                          <PolicyModal title={formatterMessage('pages.footer.text5')} filePath='Cookie.md' />
                          <PolicyModal title={formatterMessage('pages.footer.text6')} filePath='policy.md' />
                          <PolicyModal title={formatterMessage('pages.footer.text7')} filePath='Anti-Money.md' />
                          <PolicyModal title={formatterMessage('pages.footer.text8')} filePath='Service.md'/>
                      </div>
                      <div>
                          <p>{formatterMessage('pages.footer.text9')}</p>
                          <a href={media?.telegram} target="_blank">{formatterMessage('pages.footer.text10')}</a>
                          <a href={media?.discord} target="_blank">{formatterMessage('pages.footer.text11')}</a>
                      </div>
                  </Col>
              </Row>
          </div>
          <div className="footer-bottom">
              <a href="#"><img src="/logo.png" alt="" title=""/></a>
              <div className={'page-content'}>
                  <p>{formatterMessage('pages.footer.text12')}</p>
                  <p>{formatterMessage('pages.footer.text13')}: FINDTADER LIMITED</p>
                  <p>{formatterMessage('pages.footer.text14')}</p>
                  <p>{formatterMessage('pages.footer.text15')}：77159088 {formatterMessage('pages.footer.text16')}：service@findtrader.io</p>
                  <span>&copy;2025 FINDTADER LIMITED. All rights reserved.</span>
              </div>
          </div>

      </div>
  );
};

export default Footer;
